import { ObservableFromFetch } from "../ObservableFromFetch"

export default function CheckInactiveURL(url: string) {
    const requestBody = JSON.stringify({ url: url })
    return ObservableFromFetch<boolean>("FFOrderClinicFileMaintenance/InActivateUrl", requestBody)
}
